export default [
  {
    path: "/report-employees",
    name: "report-employees",
    meta: {
      title: "Выплаты сотрудникам",
      authRequired: true,
    },
    component: () => import("@/modules/reports/report-employees/views/index.vue"),
  },
];
